import type { ClientInputs } from '@botpress/client'
import { useQueryKeys } from '../hooks'
import { getApiClient } from '../stores'
import { infiniteQueryOptions } from '@tanstack/react-query'
import { cacheDuration } from '../shared'

export type ListFilesProps = { botId: string; workspaceId: string } & Pick<
  ClientInputs['listFiles'],
  'sortDirection' | 'sortField' | 'tags' | 'ids'
>
export const listFilesInfiniteQuery = ({ botId, workspaceId, sortDirection, sortField, tags }: ListFilesProps) => {
  const { listFiles } = useQueryKeys()
  const client = getApiClient({ workspaceId, botId })
  return infiniteQueryOptions({
    staleTime: cacheDuration.short,
    queryKey: listFiles({ botId, workspaceId, sortDirection, sortField, tags }),
    queryFn: async ({ pageParam }) =>
      client
        .listFiles({
          nextToken: pageParam,
          sortField,
          sortDirection,
          tags,
        })
        .catch((e) => {
          console.error('Failed to fetch files', e)
          return { files: [], meta: { nextToken: null } }
        }),
    getNextPageParam: (lastPage) => {
      return lastPage.meta.nextToken
    },
    initialPageParam: undefined as string | undefined,
    meta: {
      suppressError: true,
    },
  })
}
